import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof console !== 'undefined') {
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return React.createElement(
        'div',
        {
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: 32,
            textAlign: 'center',
            fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
          },
        },
        React.createElement('div', { style: { fontSize: 48, marginBottom: 16 } }, '!'),
        React.createElement(
          'h2',
          { style: { margin: '0 0 8px', fontWeight: 600, color: '#333' } },
          'Something went wrong'
        ),
        React.createElement(
          'p',
          { style: { margin: '0 0 24px', color: '#666', maxWidth: 400 } },
          'An unexpected error occurred. Please try again.'
        ),
        React.createElement(
          'button',
          {
            onClick: this.handleRetry,
            style: {
              padding: '10px 24px',
              fontSize: 14,
              fontWeight: 600,
              color: '#fff',
              backgroundColor: '#4f227d',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
            },
          },
          'Try Again'
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
